interface ILiveChatYouTube {
  token: string;
}

function LiveChatYouTube({ token }: ILiveChatYouTube) {
  const domain = window.location.hostname;

  return (
    <iframe
      src={`https://www.youtube.com/live_chat?v=${token}&embed_domain=${domain}`}
      className="w-full h-[600px] lg:h-[465px] lg:w-[350px]"
    ></iframe>
  );
}

export { LiveChatYouTube };
